/* BP BUNDLE v2 - Beetle Print
   'logo-incluido' es el inventario real de los 75 logos. Cada compra mete 2
   lineas atadas por la propiedad oculta _bp_bundle: leash (padre) + logo
   (hijo, 0 EUR). Aqui se garantiza: cantidad hijo == cantidad padre en
   /cart.js, cero huerfanos, tope por stock real y contador sin hijos.
   Las filas se localizan por data-cart-item-key, no por indice.
   El ocultado visual lo hace el CSS de meta-tags.liquid, no este archivo.
*/
(function () {
  var CHILD = 'logo-incluido';
  var PARENT_URL = '/products/beetle-print-lighter-leash-personalizable-picamecheros';
  var PROP = '_bp_bundle';
  var MSG_KEY = 'bp_cart_msg';
  var busy = false, again = false;

  try {
    if (location.pathname.indexOf('/products/' + CHILD) !== -1 &&
        !(window.Shopify && window.Shopify.designMode)) {
      location.replace(PARENT_URL);
      return;
    }
  } catch (e) {}

  function req(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(
        function (b) { return { ok: r.ok, body: b }; },
        function () { return { ok: r.ok, body: null }; }
      );
    });
  }
  function getCart() {
    return req('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.body; });
  }
  function change(key, qty) {
    return req('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function bundleOf(it) { return it.properties && it.properties[PROP]; }
  function isChild(it) { return it.handle === CHILD; }
  function onCartPage() { return !!document.getElementById('main-cart-items'); }

  function showMsg(msg) {
    var el = document.getElementById('bp-cart-msg');
    if (!el) {
      el = document.createElement('div');
      el.id = 'bp-cart-msg';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.display = 'none'; }, 9000);
  }

  function sync(cart) {
    var parents = {}, children = {}, jobs = [];
    cart.items.forEach(function (it) {
      var b = bundleOf(it);
      if (!b) return;
      if (isChild(it)) { children[b] = it; } else { parents[b] = it; }
    });
    Object.keys(children).forEach(function (b) {
      var c = children[b], p = parents[b];
      if (!p) { jobs.push({ c: c, q: 0 }); return; }
      if (c.quantity !== p.quantity) jobs.push({ c: c, p: p, q: p.quantity });
    });
    if (!jobs.length) return Promise.resolve(false);

    var capped = false, i = 0;
    function next() {
      if (i >= jobs.length) return Promise.resolve(capped ? 'capped' : true);
      var job = jobs[i++];
      return change(job.c.key, job.q).then(function (res) {
        if (res.ok || !job.p) return next();
        var max = job.c.quantity;
        capped = true;
        var msg = max > 0
          ? 'No queda suficiente stock de ese logo. Hemos dejado la cantidad en ' + max + '.'
          : 'Ese logo se ha agotado. Elige otro diseño.';
        try { sessionStorage.setItem(MSG_KEY, msg); } catch (e) {}
        showMsg(msg);
        return change(job.p.key, max).then(next);
      });
    }
    return next();
  }

  function paint(cart) {
    var img = {};
    cart.items.forEach(function (it) {
      var b = bundleOf(it);
      if (b && isChild(it)) img[b] = it.image;
    });
    cart.items.forEach(function (it) {
      var b = bundleOf(it);
      if (!b) return;
      var row = document.querySelector('[data-cart-item-key="' + it.key + '"]');
      if (!row) return;
      if (isChild(it)) { row.classList.add('bp-child-line'); return; }
      if (row.getAttribute('data-bp-done')) return;
      row.setAttribute('data-bp-done', '1');
      var src = img[b];
      if (!src) return;
      var host = row.querySelector('.cart-item__details') || row;
      var chip = document.createElement('div');
      chip.className = 'bp-logo-chip';
      var im = document.createElement('img');
      im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=80';
      im.alt = '';
      im.loading = 'lazy';
      var tx = document.createElement('span');
      tx.textContent = 'Tu logo';
      chip.appendChild(im);
      chip.appendChild(tx);
      host.appendChild(chip);
    });
  }

  function count(cart) {
    var n = 0;
    cart.items.forEach(function (it) { if (!isChild(it)) n += it.quantity; });
    var b = document.querySelector('.cart-count-bubble');
    if (!b && n > 0) {
      var link = document.getElementById('cart-icon-bubble');
      if (link) {
        b = document.createElement('div');
        b.className = 'cart-count-bubble';
        var s = document.createElement('span');
        s.setAttribute('aria-hidden', 'true');
        b.appendChild(s);
        link.appendChild(b);
      }
    }
    if (b) {
      var s2 = b.querySelector('span[aria-hidden="true"]') || b.firstElementChild;
      if (s2) s2.textContent = n;
      b.style.display = n > 0 ? '' : 'none';
    }
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (cart) {
      if (!cart || !cart.items) return null;
      return sync(cart).then(function (res) {
        if (res === 'capped' && onCartPage()) { location.reload(); return null; }
        return res ? getCart() : cart;
      });
    }).then(function (cart) {
      if (!cart) return;
      count(cart);
      paint(cart);
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; setTimeout(run, 60); }
    });
  }
  window.BPBundleRefresh = run;

  function watch(el) {
    if (!el || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 150);
    }).observe(el, { childList: true, subtree: true });
  }

  function init() {
    try {
      var m = sessionStorage.getItem(MSG_KEY);
      if (m) { sessionStorage.removeItem(MSG_KEY); showMsg(m); }
    } catch (e) {}
    run();
    try {
      var ev = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
      if (typeof subscribe === 'function') subscribe(ev, function () { setTimeout(run, 80); });
    } catch (e) {}
    watch(document.querySelector('cart-items'));
    watch(document.querySelector('cart-drawer'));
    try {
      if (!(window.CSS && CSS.supports && CSS.supports('selector(:has(a))'))) {
        var ls = document.querySelectorAll('a[href*="/products/' + CHILD + '"]');
        for (var k = 0; k < ls.length; k++) {
          var c = ls[k].closest('li, .card-wrapper');
          if (c && !c.closest('.cart-item')) c.style.display = 'none';
        }
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
